import { Component, Input } from '@angular/core';
import { BaseExternalUrls } from '../../../shared/enums/base-external-urls.enum';

@Component({
  selector: 'base-legal-document-links',
  templateUrl: './base-legal-document-links.component.html',
})
export class BaseLegalDocumentLinksComponent {
  @Input() increasedFontSize: boolean = false;
  baseStazzleLinks = BaseExternalUrls;
}
